import type { Group, MinifiedTask, RiskAssessmentSystemTaskData, TaskStatus } from '@gcv/shared';

import { getAssigneeName } from '../../tasks/util';

export interface RiskAssessmentDrawerRow {
  accountName: string;
  assignee: string;
  completedOn: string;
  crbId: string;
  resultId: string;
  status: TaskStatus;
  taskId: string;
}

/** One row per account a risk assessment was sent to, sorted by account. */
export const getRiskAssessmentDrawerRows = (
  groupedTasks: MinifiedTask[],
  bankGroups: Group[]
): RiskAssessmentDrawerRow[] =>
  groupedTasks
    .map((task) => ({
      accountName: task.account?.name ?? '--',
      assignee:
        task.assigned_users?.length || task.assigned_group_ids?.length
          ? getAssigneeName(bankGroups, task.assigned_users, task.assigned_group_ids, task.assigned_groups)
          : task.assigned_org?.name ?? '--',
      completedOn: task.completed_on ?? '',
      crbId: task.account?.id ?? '',
      resultId: (task.data as RiskAssessmentSystemTaskData | undefined)?.result_id ?? '',
      status: task.status,
      taskId: task.id
    }))
    .sort((a, b) => a.accountName.localeCompare(b.accountName));
